import moment from 'moment';
import { DATE_PARSE_FORMATS, YYYY_MM_DD } from '../../helpers/dateHelper';
import { isEmpty } from 'lodash';

const DataMapperPatientListTable = (data, clinician_id) => {
  let allData = [];

  function highMedLow(risk_status_a, risk_status_b) {
    return risk_status_a + risk_status_b;
  }

  if (data) {
    const weekAgo = moment().subtract(7, 'd').format('YYYY-MM-DD');

    for (let i = 0; i < data.length; i++) {
      let patient = {};
      //patient id
      patient.id = data[i].id;

      //access token
      patient.access_token = data[i].access_token;

      //first_name
      patient.first_name = data[i].first_name;

      //last_name
      patient.last_name = data[i].last_name;

      //episode closures
      patient.episodeClosures = [];

      //date of birth
      const rawDob = data[i].dob;
      if (rawDob) {
        const parsedDob = moment.utc(
          String(rawDob).trim(),
          DATE_PARSE_FORMATS,
          true,
        );
        patient.dob = parsedDob.isValid()
          ? parsedDob.format(YYYY_MM_DD)
          : rawDob;
      } else {
        patient.dob = rawDob;
      }

      //clinet_id
      patient.client_no = data[i].client_no;

      patient.phenotype =
        data[i].phenotype ??
        data[i]?.mostRecentEpocc?.phenotype ??
        data[i]?.most_recent_epocc?.phenotype ??
        data[i]?.epocc?.phenotype ??
        null;

      patient.diagnosis =
        data[i].diagnosis ?? data[i]?.primary_diagnosis ?? data[i]?.dx ?? null;

      // mypainhealth data relavent fields
      const mypainhealthData = data[i]?.myPainHealthData;
      if (!isEmpty(mypainhealthData)) {
        const dobText = patient.dob;
        const parsedDobForEligibility = dobText
          ? moment.utc(String(dobText).trim(), DATE_PARSE_FORMATS, true)
          : null;
        const years =
          parsedDobForEligibility && parsedDobForEligibility.isValid()
            ? moment().diff(parsedDobForEligibility, 'years')
            : null;
        const eligibleByAge =
          typeof years === 'number' ? years >= 16 && years <= 24 : false;
        const eligible =
          typeof mypainhealthData?.eligible === 'boolean'
            ? mypainhealthData.eligible
            : eligibleByAge;

        patient.triageCategory =
          mypainhealthData?.triageCategory?.detail?.triage_category;
        patient.phenotype = mypainhealthData?.phenotype;
        patient.lastEreferralDate = mypainhealthData?.lastEReferral ?? null;
        patient.mypainhealthEligible = eligible;
        patient.eligible = eligible;
        patient.mypainhealthInvited = mypainhealthData?.isInvited ?? false;
        patient.invited = patient.mypainhealthInvited;
        patient.mypainhealthConsent = mypainhealthData?.isConsent ?? false;
        patient.consent = patient.mypainhealthConsent;
        patient.mypainhealthLastLogin =
          mypainhealthData?.myPainHealthAppLastLogin ?? null;
        patient.lastLogin = patient.mypainhealthLastLogin;
      }

      //last_episode
      patient.last_episode = data[i].last_episode;

      //pmmEvents
      patient.pmmEvents = data[i].pmmEvents;

      //teams
      patient.teams = data[i].teams;

      //Tags
      let tags = data[i].tags.map((tag) => tag.tag_name).join('~');
      let tag_short_name = data[i].tags.map((tag) => tag.short_name).join('~');
      let tag_expiration_time = data[i].tags
        .map((tag) => {
          if (!tag.expiration_time) {
            return 'No Expiration';
          }

          const expirationDate = new Date(tag.expiration_time);
          const day = String(expirationDate.getDate()).padStart(2, '0');
          const month = String(expirationDate.getMonth() + 1).padStart(2, '0');
          const year = String(expirationDate.getFullYear()).slice(-2);
          return `${day}/${month}/${year}`;
        })
        .join('~');
      //last MHR Data
      let lastInteraction = '';

      if (data[i].lastMHRData && data[i].lastMHRData.type) {
        lastInteraction = moment(data[i].lastMHRData.data.event_date).fromNow(
          true,
        );
        switch (data[i].lastMHRData.type) {
          case 'pbs':
            lastInteraction += ' - Picked up meds';
            break;
          case 'mbs':
            lastInteraction +=
              ' - ' + (data[i].lastMHRData.group || 'unmapped MBS event');
            break;
          case 'pd_prescription':
            lastInteraction += ' - Meds prescribed';
            break;
          case 'pd_dispense':
            lastInteraction += ' - Picked up meds';
            break;
          case 'pathology':
            lastInteraction += ' - Pathology and Diagnostic';
            break;
          default:
            lastInteraction += ' - Unknown interaction type';
            break;
        }
      } else {
        lastInteraction = '-';
      }

      // Clinics & Primary Teams
      let clinics = '';
      let primaryTeams = '';
      let healthProfessionals = '';
      let lastEpisode = '';

      for (let j = 0; j < data[i].clinics.length; j++) {
        // Clinics
        if (data[i].clinics[j].clinic) {
          clinics += data[i].clinics[j].clinic;
          if (j < data[i].clinics.length - 1) {
            clinics += ', ';
          }
        }

        // Primary Teams and hps
        // const openEpisode = data[i].clinics[j].episodes.find((episode) => {
        //   return !episode.episode_closed;
        // });
        const latestEpisodeIndex =
          data[i].clinics[j].episodes.length - 1 > 0
            ? data[i].clinics[j].episodes.length - 1
            : 0;
        const latestEpisode = data[i].clinics[j].episodes[latestEpisodeIndex];
        if (latestEpisode) {
          if (
            latestEpisode.details &&
            latestEpisode.details['healthProfessionals']
          ) {
            healthProfessionals =
              latestEpisode.details['healthProfessionals'].join(', ');
          }
          primaryTeams = latestEpisode.primary_teams;
        }
        // for (let k = 0; k < data[i].clinics[j].episodes.length; k++) {
        //   data[i].clinics[j].episodes[k].find((episode) => {
        //     return !episode.episode_closed
        //   }
        //   if (data[i].clinics[j].episodes[k].primaryTeams) {
        //     primaryTeams += data[i].clinics[j].episodes[k].primary_teams;
        //     if (j < data[i].clinics.length - 1) {
        //       primaryTeams += '/';
        //     }
        //   }
        // }
        //
        // // Health Professionals
        // function extractHealthProfessionals(clinic) {
        //   let hps = [];
        //
        //   if (clinic.episodes && clinic.episodes.length > 0) {
        //     const latestEpisode = clinic.episodes[clinic.episodes.length - 1];
        //     if (latestEpisode.details && Array.isArray(latestEpisode.details['Health Professionals'])) {
        //       latestEpisode.details['Health Professionals'].map(hp => {
        //         if (!hps.includes(hp)) {
        //           hps.push(hp);
        //         }
        //       });
        //     }
        //   }
        //   return hps.join(', ');
        // }
        //
        // for (let i = 0; i < data.length; i++) {
        //   for (let j = 0; j < data[i].clinics.length; j++) {
        //     healthProfessionals = extractHealthProfessionals(data[i].clinics[j]);
        //   }
        // }

        // Episode
        if (latestEpisode && latestEpisode.episode_closed) {
          lastEpisode += 'Closed, \n';
          if (latestEpisode.episode_closed_date) {
            lastEpisode += moment(latestEpisode.episode_closed_date).format(
              'DD MMM YYYY',
            );
          }
          patient.episodeClosures.push(latestEpisode.episode_closed_date);
          if (j < data[i].clinics.length - 1) {
            lastEpisode += ', ';
          }
        } else {
          lastEpisode += 'Open';
          if (j < data[i].clinics.length - 1) {
            lastEpisode += ', ';
          }
        }

        //data.patients[i].lastInsight = (data.patients[i].lastMBS ? 100 : 0) + (data.patients[i].lastPBS ? 10 : 0) + (data.patients[i].lastPredict);
      }

      patient.lastEpisode = lastEpisode.substring(0, lastEpisode.length);

      function groupBy(arr, prop) {
        const map = new Map(Array.from(arr, (obj) => [obj[prop], []]));
        arr.forEach((obj) => map.get(obj[prop]).push(obj));
        return Array.from(map.values());
      }

      patient.sync = moment(data[i].lastSync).isAfter(weekAgo);

      //if at least one is open then remove the closures list.
      patient.episodeClosures = [];
      patient.lastInteraction = lastInteraction;
      patient.withingsData = data[i].withingsData;
      patient.clinicsData = clinics.substring(0, clinics.length);
      patient.clinicIds = data[i].clinics.map((clinic) => clinic.id);
      patient.primaryTeams = primaryTeams;
      patient.healthProfessionals = healthProfessionals;
      patient.actions = data[i].actions;
      patient.assigned = patient.actions.some(
        (action) => action.clinician_id === clinician_id,
      );
      patient.favouritedClinicians = data[i].favouritedClinicians;
      patient.favourite = data[i].favourite;
      patient.recommended = data[i].recommended;
      patient.notes = {
        tags: tags.substring(0, tags.length),
        tag_short_name: tag_short_name.substring(0, tag_short_name.length),
        tag_expiration_time: tag_expiration_time.substring(
          0,
          tag_expiration_time.length,
        ),
      };
      patient.clinicianSurveyToday = data[i].clinicianSurveyToday;

      let activeHighRiskInsights = data[i].activeInsights.filter(
        (x) => x.risk_status === 'h',
      );
      const groupedHighRisk = groupBy(activeHighRiskInsights, 'risk_status');

      let activeMediumRiskInsights = data[i].activeInsights.filter(
        (x) => x.risk_status === 'm',
      );
      const groupLowRisk = groupBy(activeMediumRiskInsights, 'risk_status');

      patient.activeInsights = {
        highriskInsight: null,
        mediumriskInsight: null,
      };

      function mapAlgoTypes(insights) {
        return insights.map((insight) => {
          const algoType =
            insight.algo_type === 'NAHLN'
              ? insight.why_created
              : insight.algo_type;
          return [algoType, insight.risk_status];
        });
      }
      patient.activeInsights.summary = mapAlgoTypes(data[i].activeInsights);

      // populate why created for active insights
      patient.activeInsights.whyCreated = data[i].activeInsights.map(
        (insight) => {
          return insight.why_created;
        },
      );

      if (patient.lastEpisode.indexOf('Open') > -1) {
        //still has at least one open case

        if (groupedHighRisk.length > 0) {
          patient.activeInsights.highriskInsight = groupedHighRisk[0][0];
          patient.activeInsights.highriskInsightNumber =
            activeHighRiskInsights.length;
          patient.activeInsights.highRiskTypes = mapAlgoTypes(
            activeHighRiskInsights,
          );
        }
        if (groupLowRisk.length > 0) {
          patient.activeInsights.mediumriskInsight = groupLowRisk[0][0];
          patient.activeInsights.mediumriskInsightNumber =
            activeMediumRiskInsights.length;
          patient.activeInsights.mediumRiskTypes = mapAlgoTypes(
            activeMediumRiskInsights,
          );
        }

        patient.healthProfessionals = healthProfessionals.substring(
          0,
          healthProfessionals.length - 2,
        );

        // dummy data
        //let Items = [ "000","001","011","010","100","101","111","110" ];
        let Items = ['000', '010', '100', '110'];
        let randomItems = Math.floor(Math.random() * Items.length);

        Items = ['redArrowDown', 'yellowArrowDown', 'greenArrowUp'];
        randomItems = Math.floor(Math.random() * Items.length);
        patient.wellBeingType = Items[randomItems];

        if (data[i]?.trends?.distressTrend != null) {
          patient.distressTrend = data[i].trends.distressTrend;
        }

        if (data[i]?.trends?.clinicalProfileTrend != null) {
          patient.clinicalProfileTrend = data[i].trends.clinicalProfileTrend;
        }

        //Items = [ "3mth - picked up meds", "2mt - Missed appointment", "7days - GP appointment", "3days - Picked up meds" ]
        //randomItems = Math.floor(Math.random() * Items.length);
        //patient.lastInteraction = Items[randomItems];

        Items = [
          'Patient survey results received',
          'Carer survey results received',
          "Reason meds missed: Couldn't afford it",
          "Reason app missed: Couldn't get there",
          '-',
          '-',
          '-',
        ];
        randomItems = Math.floor(Math.random() * Items.length);
        patient.medsChange = Items[randomItems];

        function determineEntryType(entry) {
          let entryType = ''; // Default type
          if (!entry) {
            return entryType; // Return default type or handle the undefined case as needed.
          }

          if (
            entry.preferred_name &&
            (entry.good_signs || entry.warning_signs)
          ) {
            entryType = 'Carer survey results received';
          } else if (entry.good_signs || entry.warning_signs) {
            entryType = 'Patient survey results received';
          } else if (entry.event_source) {
            if (entry.event_source === 'mbs_event') {
              entryType = `Reason appt missed: ${entry.why_created || 'No reason specified'}`;
            } else {
              entryType = `Reason meds missed: ${entry.why_created || 'No reason specified'}`;
            }
          } else if (entry.change_reasons && entry.change_reasons.length > 0) {
            entryType = `Dosage change request: ${entry.change_reasons[0]}`;
          }

          return entryType;
        }
        patient.communication = determineEntryType(data[i].communications);
      } else {
        patient.closed = true;
      }

      allData.push(patient);
    }
  }
  return allData;
};

export default DataMapperPatientListTable;
